export enum viewsTypes {
  advertiserProjects = "advertiserProjects",
  managerProjects = "managerProjects",
  bloggerOffers = "bloggerOffers",
  bloggerChannels = "bloggerChannels",
  wallet = "wallet",
}
